import { deleteGroundTruth } from '../../loopback/apiClient/groundTruthApi';
import {
  SET_GROUND_TRUTHS,
  SET_SELECTED_GROUND_TRUTH,
  UPDATE_GROUND_TRUTH,
  ADD_GROUND_TRUTH,
  GroundTruthState,
  GroundTruthActionTypes,
  GroundTruthById,
  GroundTruth,
  DELETE_GROUND_TRUTH,
} from '../types';

const initialState: GroundTruthState = {
  allIds: [],
  byId: {},
  selectedGroundTruth: undefined,
};

type NormalizedStructure = {
  allIds: number[];
  byId: GroundTruthById;
};

function constructNormalizedStructures(groundTruthList: GroundTruth[]): NormalizedStructure {
  const allIds: number[] = [];
  const byId = groundTruthList.reduce((accumulator, current) => {
    accumulator[current.id] = current;
    allIds.push(current.id);
    return accumulator;
  }, {} as GroundTruthById);
  return {
    allIds,
    byId,
  };
}

function setNormalizedGroundTruths(
  state: GroundTruthState, groundTruthList: GroundTruth[],
): GroundTruthState {
  const normalizedStructure = constructNormalizedStructures(groundTruthList);
  return {
    ...state,
    byId: normalizedStructure.byId,
    allIds: normalizedStructure.allIds,
  };
}

function updateNormalizedGroundTruth(state: GroundTruthState, gt: GroundTruth): GroundTruthState {
  let newState = state;
  if (state.byId && Object.hasOwnProperty.call(state.byId, gt.id)) {
    newState = {
      ...state,
      byId: { ...state.byId, [gt.id]: gt },
    };
  }
  return newState;
}

function addNormalizedGroundTruths(state: GroundTruthState, gt: GroundTruth[]): GroundTruthState {
  const normalizedStructure = constructNormalizedStructures(gt);
  return {
    ...state,
    byId: {
      ...state.byId,
      ...normalizedStructure.byId,
    },
    allIds: (
      state.allIds ? [...state.allIds, ...normalizedStructure.allIds] : normalizedStructure.allIds
    ),
  };
}

function deleteNormalizedGroundTruth(state: GroundTruthState, id: number): GroundTruthState {
  const newIds = state.allIds.filter((gtId) => gtId !== id);
  const { [id]: deleted, ...newById } = state.byId;
  return {
    ...state,
    byId: newById,
    allIds: newIds,
  };
}

function GroundTruthReducer(
  state = initialState, action: GroundTruthActionTypes,
): GroundTruthState {
  switch (action.type) {
    case SET_GROUND_TRUTHS:
      return setNormalizedGroundTruths(state, action.payload);
    case UPDATE_GROUND_TRUTH:
      return updateNormalizedGroundTruth(state, action.payload);
    case ADD_GROUND_TRUTH:
      return addNormalizedGroundTruths(state, action.payload);
    case DELETE_GROUND_TRUTH:
      return deleteNormalizedGroundTruth(state, action.payload);
    case SET_SELECTED_GROUND_TRUTH:
      return { ...state, selectedGroundTruth: action.payload };
    default:
      return state;
  }
}

export default GroundTruthReducer;
